<template xmlns="http://www.w3.org/1999/html">
    <div class="row">
        <div class="col-md-12 pl-0 pr-0" style="display: inline-flex;">
            <div class="col-md-3 pl-0">
                <label class="form-control-label" style="padding-top: 7px;">Search variable</label>
            </div>
            <div class="col-md-9 pl-0 pr-0">
                <input v-model="search_variable" class="form-control" type="search"/>
            </div>
        </div>
        <table class="table table-bordered table-striped table-condensed mt-1">
            <thead>
            <tr>
                <th>Variable Name</th>
                <th>Variable Value</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="all_variables.length" v-for="variable in searched_variables">
                <td>{{variable.name}}</td>
                <td>{{variable.value}}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>

import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  name: 'AllVariables',
  props: ['defaultVariables', 'fixedVariables'],
  data() {
    return {
      search_variable: '',
      timeout_id: '',
      all_variables: this.defaultVariables.concat(this.fixedVariables),
      searched_variables: []
    };
  },
  watch: {
    search_variable: function (val) {
      this.searched_variables = [];
      const vm = this;
      if (vm.timeout_id) {
        clearTimeout(vm.timeout_id);
      }
      vm.timeout_id = setTimeout(() => {
        vm.searchVariables(val);
      }, 1000);
    },
  },
  methods: {
    searchVariables(value) {
      value = value.replace(/[\[\]]/g, '');
      if (!value) {
        return;
      }
      if (value == 'all') {
        this.searched_variables = this.all_variables;
      } else {
        const searched = [];
        for (const i in this.all_variables) {
          const variable_name = this.all_variables[i].name;
          let variable_value = '';
          if (typeof this.all_variables[i].value === 'number') {
            variable_value = toString(this.all_variables[i].value);
          } else {
            variable_value = this.all_variables[i].value;
          }
          if (variable_name.search(value) != -1 || variable_value.search(value) != -1) {
            searched.push(this.all_variables[i]);
          }
        }
        this.searched_variables = searched;
      }
    }
  },
  mounted() {
  },
};

</script>
